import type { EventInput } from '@fullcalendar/core'
import type { EventImpl } from '@fullcalendar/core/internal'
import type { TimeEntry } from './timeEntry.type'

export type CalendarView = 'timeGridDay' | 'timeGridWeek' | 'dayGridMonth'

export type CalendarEventColor = 'red' | 'green' | 'blue' | 'orange' | 'yellow' | 'amber' | 'gray' | 'lime' | 'emerald' | 'teal' | 'sky' | 'violet' | 'pink' | 'rose' | 'fuchsia' | 'purple' | 'indigo' | 'cyan' | 'neutral'

export interface CalendarEventPropsTimeEntry {
  project: string
  timeEntry: TimeEntry<'withTask' | 'withProject' | 'withUser'>
  isVacation?: boolean
}

export interface CalendarEventPropsTimeEntry {
  project: string
  timeEntry: TimeEntry<'withTask' | 'withProject' | 'withUser'>
}

export interface CalendarEventPropsHoliday {}

export interface CalendarEventImpl extends EventImpl {
  extendedProps: CalendarEventPropsTimeEntry
}

export interface HolidayEventInput extends EventInput {
  duration: number
}

export type CalendarEventProps = CalendarEventPropsTimeEntry | CalendarEventPropsHoliday

export type CalendarEventInput = EventInput & CalendarEventProps

export type CalendarEvent = CalendarEventInput & {
  extendedProps: CalendarEventProps
}

export interface CalendarEventDurations {
  dateToDuration: {
    [date: string]: number
  }
  sum: number
}

export const timeEntriesEventsSourceId = Symbol('timeEntries')
export const timeEntriesActiveEntrySourceId = Symbol('activeTimeEntry')
export const timeEntryCloneEventId = Symbol('clone')
